import config from "../config"

const base_url = config.base_url

export const updateSecret = (secret) =>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/update/otpsecret', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            'credentials':'include'
        },
        body: `&secret=${secret}`,
        credentials:'include'
        }).then(res=>{
            if (res.status===200) resolve()
            else throw new Error(res.status)
        }).catch(e=>{
            reject()
        })
    }) 
}
export const disableAuthenticator = () =>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/disable/authenticator', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            'credentials':'include'
        },
        credentials:'include'
        }).then(res=>{
            if (res.status===200) resolve()
            else throw new Error(res.status)
        }).catch(e=>{
            reject()
        })
    }) 
}